var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Scrollable',{ref:"rootScroll",attrs:{"class-name":"app"}},[_c('v-app',{staticClass:"myFont"},[_c('v-fade-transition',{attrs:{"hide-on-leave":""}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }